"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewsDetail = function NewsDetail(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoaded = _useState2[0],
      setIsLoaded = _useState2[1];

  var _useState3 = (0, _react.useState)({
    news: []
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      isData = _useState4[0],
      setIsData = _useState4[1];

  var params = (0, _reactRouterDom.useParams)();
  var newsId = params.id;

  var loadData = function loadData(props) {
    fetch("https://ourwork-ccaa4-default-rtdb.europe-west1.firebasedatabase.app/news/" + props + ".json").then(function (res) {
      return res.json();
    }).then(function (data) {
      isData.news = data;
      setIsLoaded(true);
    });
  };

  (0, _react.useEffect)(function () {
    loadData(newsId);
  }, [loadData, newsId]);

  return _react2.default.createElement(
    _react.Fragment,
    null,
    isLoaded && _react2.default.createElement(
      "section",
      { className: "news-details" },
      _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement("img", { src: isData.news.image }),
        _react2.default.createElement(
          "div",
          { className: "news-details__content" },
          _react2.default.createElement(
            "h2",
            null,
            isData.news.title
          ),
          _react2.default.createElement(
            "strong",
            null,
            isData.news.intro
          ),
          _react2.default.createElement(
            "span",
            null,
            " - ",
            isData.news.date,
            " - "
          ),
          _react2.default.createElement(
            "p",
            null,
            isData.news.text
          )
        )
      )
    )
  );
};

exports.default = NewsDetail;